import { AnalyticsBrandSettings } from 'idt-analytics-api/models';

import {
  HomeEvents,
  ProductEvents,
  BundleEvents,
  HeaderEvents,
  FooterEvents,
  LookEvents,
  LoginEvents,
  GridEvents,
  MainMenuEvents,
  ColbensonSearcherEvents,
  StoreLocatorEvents,
  WorldWideEvents,
  RelatedProductsPopupEvents,
  SessionExpiredEvents,
  GenericEvents,
  NewsletterEvents,
  MinicartEvents,
  MiniwishlistEvents,
  StoreBookingEvents,
  ResetPasswordEvents,
  ContactFormEvents,
  ShopCartEvents,
  FindYourFitEvents,
  HelpCenterEvents,
  NewsletterPopupEvents,
} from './events';

export const AnalyticsBrandSetttingsOysho: AnalyticsBrandSettings = {
  ...HeaderEvents,
  ...HomeEvents,
  ...ProductEvents,
  ...BundleEvents,
  ...LoginEvents,
  ...LookEvents,
  ...MainMenuEvents,
  ...FooterEvents,
  ...GridEvents,
  ...ColbensonSearcherEvents,
  ...StoreLocatorEvents,
  ...StoreBookingEvents,
  ...WorldWideEvents,
  ...RelatedProductsPopupEvents,
  ...SessionExpiredEvents,
  ...GenericEvents,
  ...NewsletterEvents,
  ...MinicartEvents,
  ...MiniwishlistEvents,
  ...ResetPasswordEvents,
  ...ContactFormEvents,
  ...ShopCartEvents,
  ...FindYourFitEvents,
  ...HelpCenterEvents,
  ...NewsletterPopupEvents,
};
